// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"d2f92905","648":"1e29883f"}[chunkId] + ".chunk.js";
};